<template>
  <div id="app" :class="{ 'app--with-tabbar': showTabbar }">
    <template v-if="isConfigLoaded">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>

      <Teleport to="body">
        <van-tabbar
          v-if="showTabbar"
          route
          fixed
          safe-area-inset-bottom
          class="custom-tabbar"
          style="z-index: 99"
        >
          <van-tabbar-item
            v-for="(item, index) in menuList"
            :key="index"
            :to="item.path"
            :icon="item.icon"
          >
            {{ item.name }}
          </van-tabbar-item>
        </van-tabbar>
      </Teleport>
    </template>
    <div v-else class="loading-container">
      <van-loading type="spinner" color="#1989fa" size="24px" vertical>
        加载中...
      </van-loading>
    </div>
  </div>
</template>

<script setup>
import { computed, provide, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const route = useRoute();

/** 弹层打开计数：>0 时隐藏 Tabbar，避免挡弹窗 */
const overlayOpenCount = ref(0);

const setAppOverlayOpen = (open) => {
  if (open) {
    overlayOpenCount.value += 1;
  } else {
    overlayOpenCount.value = Math.max(0, overlayOpenCount.value - 1);
  }
};

provide("setAppOverlayOpen", setAppOverlayOpen);

const isConfigLoaded = computed(() => !!store.state.config.webViewConfig);

const menuList = computed(() => {
  const config = store.state.config.webViewConfig;
  return config?.page_menu_list || [];
});

const shouldShowTabbar = computed(() => {
  const currentPath = route.path;
  const inMenuList = menuList.value.some((item) => item.path === currentPath);
  const isSubPage = currentPath.split("/").length > 2;
  return inMenuList && !isSubPage;
});

const showTabbar = computed(
  () => shouldShowTabbar.value && overlayOpenCount.value === 0
);
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

#app.app--with-tabbar {
  padding-bottom: 58px;
  box-sizing: border-box;
}

/* 强制贴底，覆盖 WebView 注入的 bottom 偏移 */
html body .van-tabbar.custom-tabbar {
  position: fixed !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  transform: none !important;
  margin: 0 !important;
  padding-bottom: env(safe-area-inset-bottom) !important;
  z-index: 99 !important;
}

.custom-tabbar .van-tabbar-item {
  color: #333;
}

.custom-tabbar .van-tabbar-item--active {
  color: #1d62c1;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>
